<template>
  <div class="content">
    <base-block class="mb-0" rounded title="Create Admin">
      <div class="row">
        <div class="col-md-4 form-group">
          Name
          <input class="form-control" v-model="name" @focus="nameEmpty = false" type="text" />
            <div v-if="nameEmpty" style="color: red">
            Name is required
          </div>
        </div>
        <div class="col-md-4 form-group">
          User Name
          <input class="form-control" v-model="username" @focus="usernameEmpty = false" type="text" />
          <div v-if="usernameEmpty" style="color: red">
            UserName is required
          </div>
        </div>
        <div class="col-md-4 form-group">
          Email
          <input class="form-control" v-model="email" @focus="emailEmpty = false" type="text" />
          <div v-if="emailEmpty" style="color: red">
            Email is required
          </div>
        </div>
        <div class="col-md-6 form-group">
          Password
          <input class="form-control" v-model="password" @focus="passwordEmpty = false" type="password" />
           <div v-if="passwordEmpty" style="color: red">
            Password is required
          </div>
        </div>
        <div class="col-md-6 form-group">
          Confirm Password
          <input class="form-control" v-model="confirmpassword" @focus="confirmpasswordEmpty = false,confirmpasswordMatch = false" type="password" />
           <div v-if="confirmpasswordEmpty" style="color: red">
            confirm password is required
          </div>
           <div v-if="confirmpasswordMatch" style="color: red">
             password does not match required
          </div>
        </div>
        <div class="col-md-6 form-group">
          Role
           <b-form-select v-model="role" @change="getRoles()" required>
            <option
              v-for="(role, index) in roles"
              :key="index"
              :value="role.id"
            >
              {{ role.role }}
            </option>
          </b-form-select>
           <div v-if="roleEmpty" style="color: red">
            Role is required
          </div>
        </div>
      </div>
      <div class="text-center">
      <b-button class="text-center pt-2 pb-2 pr-4 pl-4" variant="success" style="margin-bottom: 20px;" @click="save()">Save</b-button>
      </div>
    </base-block>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data(){
    return {
      name: "",
      nameEmpty:false,
      username: "",
      usernameEmpty:false,
      email: "",
      emailEmpty:false,
      password: "",
      passwordEmpty:false,
      confirmpassword:"",
      confirmpasswordEmpty:false,
      confirmpasswordMatch:false,
      role:"",
      roleEmpty:false,
      roles:[],
    };
  },
   mounted() {
    this.getRoles();
  },
  methods: {
     async getRoles() {
      await axios
        .get(`${this.$store.getters.baseUrl}/roles`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          if(response.data.status == "success") {
            this.roles = response.data.roles;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
          
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
    async save() {
      if (this.name == "") {
        this.nameEmpty = true;
        return;
      }
       if (this.username == "") {
        this.usernameEmpty = true;
        return;
      }
       if (this.email == "") {
        this.emailEmpty = true;
        return;
      }
       if (this.password == "") {
        this.passwordEmpty = true;
        return;
      }
       if (this.confirmpassword == "") {
        this.confirmpasswordEmpty = true;
        return;
      }
      if(!(this.confirmpassword == this.password)) {
        this.confirmpasswordMatch = true;
        return;
      }
        if (this.role == "") {
        this.roleEmpty = true;
        return;
      }
      const formdata = new FormData();
      formdata.append("name", this.name);
       formdata.append("username", this.username);
        formdata.append("email", this.email);
         formdata.append("password", this.confirmpassword);
          formdata.append("role", this.role);
      await axios
        .post(`${this.$store.getters.baseUrl}/admins/add`, formdata, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          if (response.data.status == "success") {
            console.log(response);
            this.$swal("Success", "Admin added successfully", "success");
            this.$router.push({name: 'Tables Admin'});
            this.name = "";
            this.username = "";
            this.email = "";
            this.password = "";
            this.confirmpassword = "";
            this.role = "";
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
  },
};
</script>

